import { createStore } from "zustand-x";

type AppStore = {
  needsRefresh: boolean;
  updateAndReloadApplication: () => Promise<boolean>;
};

// Create the store with initial state
const appStore = createStore<AppStore>(
  {
    needsRefresh: false,
    updateAndReloadApplication: () => Promise.resolve(false),
  },
  {
    name: "AppStore",
  }
);

// Store actions for direct usage
export const appActions = {
  // Set app refresh state
  setNeedsRefresh: (state: boolean) => {
    appStore.store.setState({ needsRefresh: state });
    if (state) {
      // TODO: Fix notification store API
      // notificationStore.set.info("A new version is available. Please refresh the page.");
      console.log("A new version is available. Please refresh the page.");
    }
  },

  // Set updater function
  setUpdater: (updaterFn: () => Promise<any>) => {
    appStore.store.setState({ updateAndReloadApplication: updaterFn });
  },

  // Handle online status change
  onOnlineStatusChange: () => {
    const condition = navigator.onLine ? "online" : "offline";
    if (condition === "offline") {
      // TODO: Handle offline status
    } else {
      // TODO: Handle online status
    }
  },

  // Initialize startup event listeners
  startup: () => {
    const handleOnlineChange = () => {
      appActions.onOnlineStatusChange();
    };

    window.addEventListener("online", handleOnlineChange);
    window.addEventListener("offline", handleOnlineChange);

    return true;
  },
};

export default appStore;
